import { useTranslation } from "react-i18next";

/**
 * Placeholder privacy/consent and terms pages, bilingual by construction. Content here is
 * structural scaffolding, not reviewed legal text — see docs/SECURITY.md for what a real
 * privacy policy and consent flow for Saudi/GCC health data would need to cover before
 * clinical launch.
 */
export function PolicyPage({ variant }: { variant: "privacy" | "terms" }) {
  const { t } = useTranslation();
  const title = variant === "privacy" ? t("footer.privacy") : t("footer.terms");

  return (
    <div className="container-app max-w-3xl py-16 lg:py-20">
      <h1 className="text-3xl font-semibold text-charcoal-900">{title}</h1>
      <div className="mt-6 space-y-4 text-charcoal-600">
        <p>{t("footer.regulatoryNotice")}</p>
        <p>
          {variant === "privacy"
            ? "DOSA collects only the health information needed to provide medication therapy management, restricts access by role, and never sells or publicly exposes patient data. Full policy text pending legal review."
            : "Use of DOSA is subject to terms covering account responsibilities, the scope of the MTM service, and data handling. Full terms pending legal review."}
        </p>
      </div>
    </div>
  );
}
